// ts-gql-integrity:2de6cd8b9c536d2efe4699a77c7f49cd
/*
ts-gql-meta-begin
{
  "hash": "714f0e69a8d01c14e11a3c54082d90c8"
}
ts-gql-meta-end
*/

import * as SchemaTypes from "./@schema";
import { TypedDocumentNode } from "@ts-gql/tag";

type UserProducts_productsFragment = { readonly __typename: 'UserProducts', readonly productId: string | null, readonly friendlyName: string | null, readonly internalName: string | null };



export type type = TypedDocumentNode<{
  type: "fragment";
  result: UserProducts_productsFragment;
  name: "UserProducts_products";
  documents: SchemaTypes.TSGQLDocuments;
  fragments: SchemaTypes.TSGQLRequiredFragments<"none">
}>

declare module "./@schema" {
  interface TSGQLDocuments {
    UserProducts_products: type;
  }
}

export const document = JSON.parse("{\"kind\":\"Document\",\"definitions\":[{\"kind\":\"FragmentDefinition\",\"name\":{\"kind\":\"Name\",\"value\":\"UserProducts_products\"},\"typeCondition\":{\"kind\":\"NamedType\",\"name\":{\"kind\":\"Name\",\"value\":\"UserProducts\"}},\"directives\":[],\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"productId\"},\"arguments\":[],\"directives\":[]},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"friendlyName\"},\"arguments\":[],\"directives\":[]},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"internalName\"},\"arguments\":[],\"directives\":[]}]}}]}")
